import { render, staticRenderFns } from "./VtGrid.vue?vue&type=template&id=b468b01e&scoped=true&"
import script from "./VtGrid.vue?vue&type=script&lang=js&"
export * from "./VtGrid.vue?vue&type=script&lang=js&"
import style0 from "./VtGrid.vue?vue&type=style&index=0&id=b468b01e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b468b01e",
  null
  
)

export default component.exports